import lang from './PremiumPage.lang';
import {LINKS, SERVICES} from '@/const';

export function genStandardUser(LG) {
  return {
    name: LG(lang.StandardUser),
    content: [
      {
        name: LG(lang.Spot),
        terms: [
          {
            name: LG(lang.Trade),
            active: true,
          },
          {
            name: LG(lang.TakerAndMaker),
            active: true,
          },
          {
            name: LG(lang.ZeroFees) + ' (' + LG(lang.DailyLimit) + ' ' + LG(lang.MonthlyLimit) + ')',
            active: false,
          },
          {
            name: LG(lang.SupportsConditionalOrders),
            active: false,
          },
        ],
      },
      {
        name: LG(lang.Contract),
        terms: [
          {
            name: LG(lang.Trade),
            active: true,
          },
          {
            name: LG(lang.Taker),
            active: true,
          },
          {
            name: LG(lang.Maker),
            active: true,
          },
        ],
      },
      {
        name: LG(lang.Others),
        terms: [
          {
            name: LG(lang.InstantWithdrawal),
            active: false,
          },
          {
            name: LG(lang.NoWithdraw),
            active: false,
          },
          {
            name: LG(lang.AbilityToGift),
            active: false,
          },
        ],
      },
    ],
  };
}

export function genPremiumTrial(LG) {
  return {
    name: LG(lang.PremiumTrial),
    content: [
      {
        name: LG(lang.Spot),
        terms: [
          {
            name: LG(lang.Trade),
            active: true,
          },
          {
            name: LG(lang.TakerAndMaker),
            active: true,
          },
          {
            name: LG(lang.ZeroFees) + ' (' + LG(lang.DailyLimit) + ' ' + LG(lang.MonthlyLimit) + ')',
            active: true,
          },
          {
            name: LG(lang.SupportsConditionalOrders),
            active: false,
          },
        ],
      },
      {
        name: LG(lang.Contract),
        terms: [
          {
            name: LG(lang.Trade),
            active: true,
          },
          {
            name: LG(lang.Taker),
            active: true,
          },
          {
            name: LG(lang.Maker),
            active: true,
          },
        ],
      },
      {
        name: LG(lang.Others),
        terms: [
          {
            name: LG(lang.InstantWithdrawal),
            active: false,
          },
          {
            name: LG(lang.NoWithdraw),
            active: false,
          },
          {
            name: LG(lang.AbilityToGift),
            active: false,
          },
        ],
      },
    ],
  };
}

export function genPremium(LG) {
  return {
    name: LG(lang.Premium),
    content: [
      {
        name: LG(lang.Spot),
        terms: [
          {
            name: LG(lang.Trade),
            active: true,
          },
          {
            name: LG(lang.TakerAndMaker),
            active: true,
          },
          {
            name: LG(lang.ZeroFees) + ' (' + LG(lang.DailyLimit) + ' ' + LG(lang.MonthlyLimit) + ')',
            active: true,
          },
          {
            name: LG(lang.SupportsConditionalOrders),
            active: true,
          },
        ],
      },
      {
        name: LG(lang.Contract),
        terms: [
          {
            name: LG(lang.Trade),
            active: true,
          },
          {
            name: LG(lang.Taker),
            active: true,
          },
          {
            name: LG(lang.Maker),
            active: true,
          },
        ],
      },
      {
        name: LG(lang.Others),
        terms: [
          {
            name: LG(lang.InstantWithdrawal),
            active: true,
          },
          {
            name: LG(lang.NoWithdraw),
            active: true,
          },
          {
            name: LG(lang.AbilityToGift),
            active: true,
          },
        ],
      },
    ],
  };
}

export function genFrequentlyAskedQuestions(LG) {
  return {
    content: [
      {
        questions: LG(lang.Question_1),
        answer: LG(lang.Answer_1),
      },
      {
        questions: LG(lang.Question_2),
        answer: `<div>
                ${LG(lang.Answer_2)}
                <a class="cp" href=${LINKS.PHEMEX_CUSTOMER_SERVICE} target="_blank" rel="noopener noreferrer nofollow">${LG(lang.Answer_5)}</a>
                ${LG(lang.Answer_6)}
                </div>`,
      },
      {
        questions: LG(lang.Question_3),
        answer: LG(lang.Answer_3),
      },
      {
        questions: LG(lang.Question_4),
        answer: LG(lang.Answer_4),
      },
    ],
  };
}

const PREFIX = `${SERVICES.STATIC_URL}/s/web/account/`;
export const BANNER_RIGHT = PREFIX + 'banner_right_v1.png';
export const BANNER = PREFIX + 'banner.png';
export const ASK_FOR = PREFIX + 'ask_for_v1.svg';
export const NOTIFICATION = PREFIX + 'notification.svg';
export const NOTIFICATION_WARING = PREFIX + 'notification_waring.svg';
export const PAY_ERROR = PREFIX + 'payerror_v1.svg';
export const PAY_SUCCESS = PREFIX + 'paysuccess_v1.svg';
export const TWITTER = 'https://img.phemex.com/v1/c80f707e-e491-410c-b9ed-e28fdf5e3d6c/twitter.svg';
export const TEL = PREFIX + 'tel.svg';
export const FACEBOOK = PREFIX + 'facebook.svg';
export const MOST = PREFIX + 'most.png';
export const SEVEN_DAYS = PREFIX + '7days.png';
export const THIRTY_DAYS = PREFIX + '30days.png';
export const PHEMEX_WECHAT = PREFIX + 'wechat.png';

const PREFIX_RECEIVE = `${SERVICES.STATIC_URL}/pubimg/`;
export const Icons = {
  BANNER: '22f93ff65135db944fb3a6f800e73730045c3fdde2f271fa6d2ffe1ed40a9dc4.png',
};

Object.keys(Icons).forEach((key) => (Icons[key] = [PREFIX_RECEIVE, Icons[key]].join('')));
